import { motion } from 'framer-motion';

/**
 * VectorDB + RAG 섹션 비주얼.
 * 노드 플로우 대신 "검색 결과 UI" 양식으로 차별화한다.
 * 검색바 + 하이브리드 검색 파이프라인 칩 + 관련도 점수바가 있는 랭킹 결과 카드.
 */

const PIPELINE = ['데이터 프로파일링', '임베딩', 'BM25 + 벡터', '리랭킹'];

const RESULTS = [
  {
    title: '4분기 예산 심의 회의록',
    snippet: '…예비비 12% 증액 의결, 집행 시점은 익월로…',
    source: '회의록 · p.2',
    score: 96,
  },
  { title: '집행계획서 v3', snippet: '…부서별 배정안과 우선순위 항목 정리…', source: '공공문서', score: 88 },
  { title: '전분기 실적 보고', snippet: '…미집행 잔액 이월 근거 및 사유…', source: '보고서', score: 71 },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.15 } },
};
const row = {
  hidden: { opacity: 0, y: 14 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
};

export default function RagSearchDemo() {
  return (
    <div className="ai-search">
      <div className="ai-search__bar">
        <span className="ai-search__ic" aria-hidden>
          ⌕
        </span>
        <span className="ai-search__q">지난 분기 예산 결정 사항</span>
        <span className="ai-search__tag">하이브리드 검색</span>
      </div>

      <div className="ai-search__pipe">
        {PIPELINE.map((p, i) => (
          <span key={p} className="ai-search__pipe-item">
            {p}
            {i < PIPELINE.length - 1 && <i className="ai-search__pipe-arrow">→</i>}
          </span>
        ))}
      </div>

      <motion.div
        className="ai-search__results"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.4 }}
      >
        {RESULTS.map((r) => (
          <motion.div className="ai-search__card" variants={row} key={r.title}>
            <div className="ai-search__card-head">
              <span className="ai-search__card-title">{r.title}</span>
              <span className="ai-search__score">{r.score}</span>
            </div>
            <div className="ai-search__snippet">{r.snippet}</div>
            <div className="ai-search__meta">
              <span className="ai-search__source">{r.source}</span>
              <span className="ai-search__bar-track">
                <motion.span
                  className="ai-search__bar-fill"
                  initial={{ width: 0 }}
                  whileInView={{ width: `${r.score}%` }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.9, ease: 'easeOut', delay: 0.3 }}
                />
              </span>
            </div>
          </motion.div>
        ))}
      </motion.div>

      <div className="ai-diagram__caption">임베딩·하이브리드 검색·리랭킹으로 근거를 출처와 함께 인용</div>
    </div>
  );
}
